import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const Application = {
    BMP: "BMP",
    BAM: "BAM",
} as const;

export type Application = (typeof Application)[keyof typeof Application];

export interface ApplicationState {
    selected: Application;
}

const LOCAL_STORAGE_KEY = "selectedApplication";

const readPersistedApplication = (): Application => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === Application.BAM || stored === Application.BMP) {
        return stored;
    }
    return Application.BMP;
};

const INITIAL_STATE: ApplicationState = {
    selected: readPersistedApplication(),
};

const applicationSlice = createSlice({
    name: "application",
    initialState: INITIAL_STATE,
    reducers: {
        setApplication(state, action: PayloadAction<Application>) {
            state.selected = action.payload;
            localStorage.setItem(LOCAL_STORAGE_KEY, action.payload);
        },
    },
});

export const { setApplication } = applicationSlice.actions;

export default applicationSlice.reducer;
